import { Star, Lock } from "lucide-react";
import { LEARN } from "@/constants/testIds";
import { difficultyOf } from "./constants";

export function LessonCard({ l, catName, Icon, onFav, onOpen }) {
  const status = l.completed ? "Completed" : null;
  return (
    <div className="relative">
      <button onClick={() => onOpen(l.id)} data-testid={`${LEARN.lessonCard}-${l.id}`}
        className="w-full text-left bg-white rounded-3xl card-soft hover:-translate-y-0.5 transition-smooth flex flex-col h-full min-h-[220px] overflow-hidden">
        <div className="flex items-center justify-between px-6 pt-6">
          <div className="w-11 h-11 rounded-2xl bg-[#F7F2EA] flex items-center justify-center">
            <Icon className="text-[#291B2D]" size={18} strokeWidth={1.6} />
          </div>
          {l.locked ? (
            <span data-testid={`lesson-locked-${l.id}`} className="inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full uppercase tracking-widest bg-[#291B2D]/90 text-white"><Lock size={11} /> Members</span>
          ) : status && <span className="text-[10px] px-2 py-0.5 rounded-full uppercase tracking-widest bg-[#ECF3EE] text-[#3D6B52]">{status}</span>}
        </div>
        <div className="flex flex-col flex-1 p-6 pt-4">
          <p className="text-[10px] uppercase tracking-widest text-[#291B2D]/50 mb-1">{catName}</p>
          <p className="font-heading text-lg leading-snug mb-2 line-clamp-2">{l.title}</p>
          <p className="text-sm text-[#291B2D]/60 leading-relaxed line-clamp-3 flex-1">{l.summary}</p>
          <p className="text-[10px] text-[#291B2D]/40 uppercase tracking-widest mt-3">{l.minutes} min · {difficultyOf(l.minutes)}</p>
        </div>
      </button>
      <button onClick={() => onFav(l.id)} data-testid={`fav-${l.id}`} aria-label={l.bookmarked ? "Unsave" : "Save"}
        className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-white/90 backdrop-blur flex items-center justify-center card-soft hover:scale-110 transition-smooth">
        <Star size={14} className={l.bookmarked ? "text-[#C89B55] fill-[#C89B55]" : "text-[#291B2D]/30"} strokeWidth={2} />
      </button>
    </div>
  );
}
